/* <Pills type={'ghost'} color={'white'} text={'Pill text'} icon={'check_circle'}></Pills> */
import './pill.css';
import Icon from '../icon/icon';
const Pills = ({type, color, text, icon}) => {

    const specialColors = ['violet', 'calipso'];
    const textEval = () => {
        return (type === 'filled' && specialColors.includes(color)) ? 'white': type === 'filled'?'carbon':color;
    }

   const iconEval = () => {
        const colors = {
            white:'rgba(255, 255, 255, 1)',
            gray:'rgba(192, 192, 192, 1)',
            violet:'rgba(119, 54, 215, 1)',
            calipso:'rgba(52, 149, 215, 1)',
            carbon:'rgba(51, 51, 51, 1)'
        };
        
        if (icon === 'none') return '';

        let finalColor = '';

        if (type === 'filled') {
            finalColor = specialColors.includes(color)
                ? colors[color]   // <-- CORREGIDO
                : colors.carbon;
        } else {
            finalColor = colors[color]; // <-- CORREGIDO
        }

        return <Icon source={icon} color={finalColor} />;
    };

    return(
        <div className={`pill pill--${type} pill--${color} pill--text--${textEval()}`}>
            {iconEval()}
            <div className="pill-text">{text}</div>
        </div>
    )
}

export default Pills;